import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatTableDataSource, MatSnackBar } from '@angular/material';
import { CreateEjeComponent } from '../../create-eje/create-eje.component';
import { Handle } from 'src/app/handle';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { GatewayService } from 'src/app/gateway.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmacionComponent } from '../../confirmacion/confirmacion.component';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { Md5 } from 'ts-md5/dist/md5';
@Component({
  selector: 'app-create-administrador',
  templateUrl: './create-administrador.component.html',
  styleUrls: ['./create-administrador.component.scss']
})
export class CreateAdministradorComponent implements OnInit {
  //displayedColumns = ['CAMPANA', 'REGISTROS', 'CONTACTO', 'EFECTIVIDAD', 'CONVERSION', 'BORRAR'];
  displayedColumns = ['CAMPANA', 'CONTACTO', 'EFECTIVIDAD', 'CONVERSION', 'TMO', 'LLAMADAS', 'LLAMADASCEP', 'BORRAR'];
  displayedColumnsLog = ['ACCION', 'COMENTARIO', 'FECHA'];
  displayedColumnsLogRol = ['ROLN', 'ROLA', 'COMENTARIO', 'FECHA'];

  dataSource = new MatTableDataSource<any>([]);
  dataSourceLog = new MatTableDataSource<any>([]);
  dataSourceLogRol = new MatTableDataSource<any>([]);
  FILTER; resultsLength = 0;
  public roles = [];
  table = [];
  tablelog = [];
  tablelogrol = [];
  campanas = [];
  maxDate = new Date();
  areas = [];

  constructor(
    private localSave: LocalSaveService,
    private spinner: NgxSpinnerService,
    private snackbar: MatSnackBar,
    private gateway: GatewayService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<CreateAdministradorComponent>, public Handle: Handle,
    @Inject(MAT_DIALOG_DATA) public data: any) { }
  operacion = 'createadministrador';
  idagente = '';
  idpais = 5;

  passaux = '';

  ngOnInit() {
    this.idpais = this.data.agente.idpais || 5;
    // this.getCampanas();
    // this.getRoles();
    // this.getHistorico();
    this.getAreas();
    this.roles = [{ idrol: 16, nombre: 'Administrador' }];
    // this.grupoVal.controls.ROL.setValue(16);
    if (this.data.operacion == 'Editar') {
      this.operacion = 'editadministrador';
      this.idagente = this.data.agente.idagente;
      this.grupoVal.controls.NOMBRE.setValue(this.data.agente.nombre);
      this.grupoVal.controls.APELLIDO.setValue(this.data.agente.apellido);
      // this.grupoVal.controls.ROL.setValue(16);
      this.grupoVal.controls.AREA.setValue(this.data.agente.idarea);
      this.grupoVal.controls.FECHA_NACIMIENTO.setValue(this.data.agente.fechanacimiento);
      this.grupoVal.controls.GENERO.setValue(this.data.agente.genero);
      this.grupoVal.controls.CORREO.setValue(this.data.agente.correo);
      this.grupoVal.controls.CORREO2.setValue(this.data.agente.correo2);
      this.grupoVal.controls.TELEFONO.setValue(this.data.agente.telefono);
      this.grupoVal.controls.PROFESION.setValue(this.data.agente.profesion);
      this.grupoVal.controls.PASS.setValue(this.data.agente.pass);
      this.grupoVal.controls.CUENTA.setValue(this.data.agente.cuenta);
      this.grupoVal.controls.TOKEN.setValue(this.data.agente.token);
      this.grupoVal.controls.URL.setValue(this.data.agente.url);
      this.grupoVal.controls.CONFIGCANAL.setValue(this.data.agente.configcanal);
      this.passaux = this.data.agente.pass;
      // this.onInputChange();
    }
  }

  getLista() {
    this.gateway.get('campanasagente', { IDAGENTE: this.data.agente.idagente }).then((result) => {

      let aux: any = result;
      this.table = aux.rows;

      // console.log('table');
      // console.log(this.data.agente.idagente);
      // console.log(this.table);

      this.table.forEach(element => {
        element.campana = this.campanas.find((mini) => {
          return mini.idcampana == element.idcampana;
        })
      });
      // console.log(this.table);
      this.dataSource = new MatTableDataSource<any>(this.table);
    }
    ).catch(function (e) {
      // console.log('e')
      // console.log(e)
    });
  }

  getAreas() {
    this.gateway.get('getallarea', {}).then((result) => {
      let aux: any = result;
      this.areas = aux.rows;
      // console.log(this.areas)
    }
    ).catch(function (e) { });
  }

  getHistorico() {

    this.gateway.get('historicoagente', { IDAGENTE: this.data.agente.idagente }).then((result) => {

      let aux: any = result;
      this.tablelog = aux.rows;
      this.dataSourceLog = new MatTableDataSource<any>(this.tablelog);
    }
    ).catch(function (e) { });

    this.gateway.get('historicoagenterol', { IDAGENTE: this.data.agente.idagente }).then((result) => {

      let aux: any = result;
      this.tablelogrol = aux.rows;
      // console.log(this.tablelogrol)
      this.dataSourceLogRol = new MatTableDataSource<any>(this.tablelogrol);
    }
    ).catch(function (e) { });
  }

  getCampanas() {
    this.gateway.get('listacampanas', { IDDISTRIBUIDOR: this.localSave.get('usuarioPGV').IDU, NUM_PAGINA: 0, FILTRO: this.FILTER, NUM_ELEMENTOS: 5, IDPAIS: this.idpais }).then((result) => {
      let aux: any = result;
      this.campanas = aux.rows;
      this.getLista();
    }
    ).catch(function (e) {
    });
  }

  setkpis(element) {
    // console.log(element.value)
    this.grupoVal2.controls.CONTACTO.setValue(element.value.contacto);
    this.grupoVal2.controls.EFECTIVIDAD.setValue(element.value.efectividad);
    this.grupoVal2.controls.CONVERSION.setValue(element.value.conversion);
    this.grupoVal2.controls.TMO.setValue(element.value.tmo);
    this.grupoVal2.controls.LLAMADAS.setValue(element.value.llamadas);
    this.grupoVal2.controls.LLAMADASCEP.setValue(element.value.llamadascep);
  }

  addCampana() {
    let campana = {
      campana: this.grupoVal2.controls.CAMPANA.value,
      registros: 0,
      contacto: this.grupoVal2.controls.CONTACTO.value,
      efectividad: this.grupoVal2.controls.EFECTIVIDAD.value,
      conversion: this.grupoVal2.controls.CONVERSION.value,
      tmo: this.grupoVal2.controls.TMO.value,
      llamadas: this.grupoVal2.controls.LLAMADAS.value,
      llamadascep: this.grupoVal2.controls.LLAMADASCEP.value,
    }
    // console.log(this.table.find(element => { return element.CAMPANA.IDCAMPANA == campana.CAMPANA.IDCAMPANA }))

    if (this.table.find(element => { return element.campana.idcampana == campana.campana.idcampana })) {
      this.snackbar.open('Ya tiene asignada la campaña', '', {
        duration: 3000,
      });
      return;
    } else {

      //console.log(this.table.length)
      if (this.table.length > 0) {
        //console.log('mayor')
        this.spinner.show();
        //console.log({CAMPANAS:this.table,NUEVA:campana})
        this.gateway.save('validatraslapecampana', { CAMPANAS: this.table, NUEVA: campana }).then((result: any) => {
          // console.log(result)
          // if (result.validacion == 0) {

          this.spinner.hide();
          this.table.push(campana);
          this.dataSource = new MatTableDataSource<any>(this.table);
          // } else {
          //   this.spinner.hide();
          //   this.snackbar.open('No puedes agregar esta campaña debido a traslape de horario con otras campañas.', 'Cerrar', {
          //     duration: 5000,
          //   });
          // }

        })
      } else {
        //console.log('vacio')
        this.table.push(campana);
        this.dataSource = new MatTableDataSource<any>(this.table);
      }
    }

  }

  onNoClick() {
    this.dialogRef.close(false);
  }

  delete(element) {
    //console.log(element);
    let auxind = -1;
    // this.table.forEach((item, index) => {
    //   //console.log(item.idcampana === element.idcampana)
    //   if (item.idcampana === element.idcampana) auxind = index; //this.table.splice(index, 1);
    // });
    auxind = this.table.indexOf(element);
    this.table.splice(auxind, 1)
    this.dataSource = new MatTableDataSource(this.table);
  }

  getRoles() {
    this.gateway.get('listaroles', { NUM_PAGINA: 0, FILTRO: this.FILTER, NUM_ELEMENTOS: 5, IDPAIS: this.idpais }).then((result) => {
      // console.log(result);
      let aux: any = result;
      this.roles = aux.rows;
    }
    ).catch(function (e) {
    });
  }

  crear() {

    let md5 = new Md5();
    let agente = {
      NOMBRE: this.grupoVal.controls.NOMBRE.value,
      APELLIDO: this.grupoVal.controls.APELLIDO.value,
      // IDROL: this.grupoVal.controls.ROL.value,
      IDAREA: this.grupoVal.controls.AREA.value,
      FECHANACIMIENTO: this.grupoVal.controls.FECHA_NACIMIENTO.value,
      GENERO: this.grupoVal.controls.GENERO.value,
      CORREO: this.grupoVal.controls.CORREO.value,
      CORREO2: this.grupoVal.controls.CORREO.value, // this.grupoVal.controls.CORREO2.value,
      PASSWORD: md5.appendStr('CPER3c0b3ry.2024').end(), // md5.appendStr(this.grupoVal.controls.PASS.value).end(),
      TELEFONO: this.grupoVal.controls.TELEFONO.value,
      PROFESION: this.grupoVal.controls.PROFESION.value,
      // IDPAIS: this.idpais,
      PASSAUX: md5.appendStr(this.passaux).end(),
      IDAGENTE: this.idagente,
      IDSUPADMIN: this.localSave.get('usuarioPGV').IDU
    }

    // if (this.data.operacion == 'Editar' && this.data.agente.pass == this.grupoVal.controls.PASS.value) {
    //   agente.PASSAUX = agente.PASSWORD = this.grupoVal.controls.PASS.value;
    // }

    if (this.operacion == 'editadministrador') {
      this.spinner.show();
      this.gateway.save(this.operacion, agente).then((result) => {
        this.spinner.hide();
        this.snackbar.open('Datos almacenados con éxito.', 'Cerrar', { duration: 3000, });
        this.dialogRef.close(true);
      }).catch(function (e) { });
    } else {

      this.spinner.show();
      this.gateway.save(this.operacion, agente).then((result) => {
        this.spinner.hide();
        this.snackbar.open('Datos almacenados con éxito.', 'Cerrar', { duration: 3000, });
        this.dialogRef.close(true);
      }).catch(function (e) { });

    }
  }

  cambiarPerfil(agente) {
    const dialogperf = this.dialog.open(ConfirmacionComponent, {
      disableClose: true,
      width: '450px',
      data: { operacion: 'editagentehistorico', id: { NUEVO: agente, ANTERIOR: this.data.agente }, msj: 'cambiar el perfil del agente', snackb: 'Comentario almacenado con éxito' }
    });

    dialogperf.afterClosed().subscribe((result) => {

      if (result) {
        this.spinner.show();
        this.gateway.save(this.operacion, agente).then((result) => {

          if (this.data.operacion == 'Crear') {
            let aux2: any = result

            this.idagente = aux2.rows[0].crear_agente;//result[0][0]['LAST_INSERT_ID()'];
          }

          if (agente.IDROL != 16) {
            this.table = [];
          }

          let ASG = {
            IDAGENTE: this.idagente, LISTA: this.table
          }
          this.gateway.save('asignarcampana', ASG).then((check) => {
            this.spinner.hide();
            this.snackbar.open('Datos almacenados con éxito.', 'Cerrar', { duration: 3000, });
            this.dialogRef.close(true);
          }).catch(function (e) { });
        }).catch(function (e) { });
      }
    });
  }

  passwordRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?["."#?!@$%^&*-])/;
  grupoVal = new FormGroup({
    NOMBRE: new FormControl('', [Validators.compose([
      Validators.required, Validators.minLength(2), Validators.maxLength(30),
      Validators.pattern("[a-z A-Z ñÑáéíóúÁÉÍÓÚ]+")
    ])]),
    APELLIDO: new FormControl('', Validators.compose([
      Validators.required, Validators.minLength(2), Validators.maxLength(30),
      Validators.pattern("[a-z A-Z ñÑáéíóúÁÉÍÓÚ]+")
    ])),
    // ROL: new FormControl(16, Validators.compose([
    //   Validators.required
    // ])),
    AREA: new FormControl(null, Validators.compose([
      Validators.required
    ])),
    FECHA_NACIMIENTO: new FormControl('', Validators.compose([
      Validators.required
    ])),
    GENERO: new FormControl('', Validators.compose([
      Validators.required
    ])),
    // CORREO: new FormControl('', Validators.compose([
    //   Validators.required
    // ])),
    CORREO: new FormControl('', Validators.compose([
      Validators.pattern("[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")
    ])),
    CORREO2: new FormControl(''),
    // CORREO2: new FormControl('', Validators.compose([
    //   Validators.pattern("[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")
    // ])),
    // PASS: new FormControl('', Validators.compose([
    //   Validators.required, Validators.minLength(8), Validators.pattern(this.passwordRegex)
    // ])),
    PASS: new FormControl(''),
    TELEFONO: new FormControl('', Validators.compose([
      Validators.required, Validators.pattern('[2-9]{1}[0-9]{7}')
    ])),
    PROFESION: new FormControl('', Validators.compose([
      Validators.required, Validators.minLength(2), Validators.maxLength(30),
      Validators.pattern("[a-z A-Z ñÑáéíóúÁÉÍÓÚ]+")
    ])),
    CUENTA: new FormControl(''),
    TOKEN: new FormControl(''),
    URL: new FormControl(''),
    CONFIGCANAL: new FormControl('')

  });

  generos: any = [
    { ID: 0, NOMBRE: 'Femenino' },
    { ID: 1, NOMBRE: 'Masculino' }
  ];

  grupoVal2 = new FormGroup({
    CAMPANA: new FormControl('', [Validators.compose([
      Validators.required
    ])]),
    CONTACTO: new FormControl('', Validators.compose([
      Validators.required, Validators.min(0), Validators.max(100)
    ])),
    EFECTIVIDAD: new FormControl('', Validators.compose([
      Validators.required, Validators.min(0), Validators.max(100)
    ])),
    CONVERSION: new FormControl('', Validators.compose([
      Validators.required, Validators.min(0), Validators.max(100)
    ])),
    TMO: new FormControl('', Validators.compose([
      Validators.required, Validators.min(0)
    ])),
    LLAMADAS: new FormControl('', Validators.compose([
      Validators.required, Validators.min(0)
    ])),
    LLAMADASCEP: new FormControl('', Validators.compose([
      Validators.required, Validators.min(0)
    ])),
  });

  onInputChange() {
    // if (this.data.operacion == 'Editar'
    //   && this.grupoVal.controls.PASS.value != ''
    //   && this.data.agente.pass == this.grupoVal.controls.PASS.value) {
    //   this.grupoVal.get('PASS').setValidators(Validators.compose([
    //     Validators.required, Validators.minLength(8)
    //   ]))
    //   this.grupoVal.get('PASS').updateValueAndValidity();
    // } else {
    //   this.grupoVal.get('PASS').setValidators(Validators.compose([
    //     Validators.required, Validators.minLength(8), Validators.pattern(this.passwordRegex)
    //   ]))
    //   this.grupoVal.get('PASS').updateValueAndValidity();
    // }
  }

}
